const DELETE_ACCOUNT_WARNING = "deleteAccountWarning"
const DELETE_ACCOUNT_CONFIRMATION = "deleteAccountConfirmation"
const SCHEDULE_DELETION = "scheduleDeletion"
const ACCOUNT_STATUS_WARNING = "accountStatusWarning"
const ACCOUNT_STATUS_CONFIRMATION = "accountStatusConfirmation"
const DELETE_ACCOUNT_UNAVAILABLE = "deleteAccountUnavailable"
const CANCEL_DELETION = "cancelDeletion"
const DEACTIVATED = "deactivated"

export {
  DELETE_ACCOUNT_WARNING,
  DELETE_ACCOUNT_CONFIRMATION,
  SCHEDULE_DELETION,
  ACCOUNT_STATUS_WARNING,
  ACCOUNT_STATUS_CONFIRMATION,
  DELETE_ACCOUNT_UNAVAILABLE,
  CANCEL_DELETION,
  DEACTIVATED
}
